import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { makeStyles } from "tss-react/mui";
import { styles } from "./style";

interface Props
	extends WithStyles<typeof styles>,
		React.HTMLAttributes<HTMLDivElement> {
	phrase: string;
	diameter?: number;
	src?: string;
}

const getLetters = (phrase: string) => {
	return phrase?.split(" ")
		.filter((word, index, array) => {
			return index === 0 || index === array.length - 1;
		})
		.map((word) => {
			return word.charAt(0).toUpperCase();
		})
		.join("");
};

const useStyles = makeStyles<Props>()((theme, props) => {
	const diameter = props.diameter || 36;
	return {
		avatar: {
			width: diameter,
			height: diameter,
			fontSize: diameter * 0.5,
			...(props.color && { backgroundColor: props.color }),
		},
	};
});

const Component = (props: Props) => {
	const { className, src, phrase } = props;
	const { classes, cx } = useStyles(props);
	const letters = getLetters(phrase);
	return (
		<Mui.Avatar
			{...props}
			classes={{
				// merge the sheet's size/color class with any external override drilled via the HOC's classes prop
				root: cx(classes.avatar, props.classes?.avatar, className),
			}}
			src={src}
		>
			{letters}
		</Mui.Avatar>
	);
};

export const Avatar = withStyles(Component, styles);
